import React from 'react';
import { User, Users, Activity, List, Smile, Frown, Meh, Calendar, Pause, Mail, Check, GitMerge, Settings, } from '../Icons/index.js';
export const FILTER_ICONS = {
    activity: React.createElement(Activity, null),
    users: React.createElement(Users, null),
    user: React.createElement(User, null),
    list: React.createElement(List, null),
    smile: React.createElement(Smile, null),
    frown: React.createElement(Frown, null),
    meh: React.createElement(Meh, null),
    calendar: React.createElement(Calendar, null),
    paused: React.createElement(Pause, null),
    mail: React.createElement(Mail, null),
    bool: React.createElement(Check, null),
    workflow: React.createElement(GitMerge, null),
    custom: React.createElement(Settings, null),
};
//# sourceMappingURL=icons.js.map